import { render, staticRenderFns } from "./ProductSkusSelector.vue?vue&type=template&id=45bed8b4&scoped=true&lang=pug"
import script from "./ProductSkusSelector.vue?vue&type=script&lang=js"
export * from "./ProductSkusSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductSkusSelector.vue?vue&type=style&index=0&id=45bed8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bed8b4",
  null
  
)

export default component.exports